import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { DepositData, WithdrawData } from "src/_models";
import { Partner } from "src/_models/partner";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./deposit-modal.html",
  styleUrls: ["./deposit.component.scss"],
})
export class DepositFundsComponent {
  currencyList: Partner[] = [];
  title: string;
  operatorId: string;
  operatorName: string;
  depositPostData: DepositData;
  withdrawPostData: WithdrawData;
  partnerIdData;
  hide = false;

  constructor(
    public dialogRef: MatDialogRef<DepositFundsComponent>,
    @Inject(MAT_DIALOG_DATA) public Data,
    private appService: AppService
  ) {
    this.title = Data.title;
    this.operatorName = Data.operatorName;
    this.operatorId = Data.operatorId;
  }

  operatorData = [];
  ngOnInit() {
    this.depositPostData = new DepositData({
      OperatorId: this.operatorId,
      PartnerId: "",
      CreditAmount: "",
      PassKey: "",
      Currency: "",
    });

    this.withdrawPostData = new WithdrawData({
      OperatorId: this.operatorId,
      PartnerId: "",
      DebitAmount: "",
      PassKey: "",
      Currency: "",
    });

    this.getPartnerIds(this.operatorId);
  }

  getPartnerIds(operatorId) {
    try {
      this.appService.getPartnerId(operatorId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.partnerIdData = res.partnerIds;

          if (res && res.partnerIds.length > 0) {
            this.currencyList = res.partnerIds;
          }
        }
      });
    } catch (err) {}
  }

  onFormSubmitWithdraw({
    value,
    valid,
  }: {
    value: WithdrawData;
    valid: boolean;
  }) {
    const withPostBody: WithdrawData = {
      OperatorId: this.operatorId,
      PartnerId: value.Currency,
      DebitAmount: value.DebitAmount,
      PassKey: value.PassKey,
    };

    try {
      this.appService.withdrawFunds(withPostBody).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close({ isSuccess: true });
          this.appService.openSuccessBar("successfully");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {
      console.log("err", err);
    }
  }

  onFormSubmit({ value, valid }: { value: DepositData; valid: boolean }) {
    this.depositPostData = value;
    this.depositPostData.PartnerId;

    const postBody: DepositData = {
      OperatorId: this.operatorId,
      PartnerId: value.Currency,
      CreditAmount: value.CreditAmount,
      PassKey: value.PassKey,
      // Currency: value.Currency,
    };

    try {
      console.log(postBody);
      this.appService.depositFunds(postBody).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close({ isSuccess: true });
          this.appService.openSuccessBar("successfully");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {
      console.log("err", err);
    }
  }
}
